import ActionTypes from '../actionTypes';

export const startLoading = () => (dispatch) => dispatch({ type: ActionTypes.START_LOADING });
export const stopLoading = () => (dispatch) => dispatch({ type: ActionTypes.STOP_LOADING });
